import { SET_HOME_TOUR_COMPLETE } from '../actions/tour';

const initialState = {
	runHomeTour: { runHomeTour: false, action: 'start' },
};

export default function (state = initialState, action) {
	switch (action.type) {
		case SET_HOME_TOUR_COMPLETE:
			return { ...state, runHomeTour: action.state };
		default:
			return state;
	}
}
